import { ReactNode } from 'react';
import './Layout.css';

interface LayoutProps {
    children: ReactNode;
}

const MONERIS_LOGO = 'https://files.readme.io/75d2e275cbfa3b9a58785fd15fe22f738bee02aec16b8036f1abd2c7c46d79bf-moneris-logo-light.webp';

function Layout({ children }: LayoutProps) {
    return (
        <div className="layout">
            <header className="header">
                <img
                    src={MONERIS_LOGO}
                    alt="Moneris"
                    className="logo"
                />
                <h1 className="title">Hosted Tokenization</h1>
                <div className="divider" />
            </header>
            <main className="content">
                {children}
            </main>
            <footer className="footer">
                &#128274; PCI DSS Compliant &middot; Powered by Moneris
            </footer>
        </div>
    );
}

export default Layout;
